import { USER_PROFILE_PAGE_HEADER_FOOTER_ACTION } from '../../UserProfilePageHeaderFooter.constants'
import { useUserProfilePageCreateContractAction } from '../useUserProfilePageCreateContractAction'
import { useUserProfilePageCreateEmailAction } from '../useUserProfilePageCreateEmailAction'
import { useUserProfilePageCreateFolderAction } from '../useUserProfilePageCreateFolderAction'
import { useUserProfilePageCreateServiceRequestAction } from '../useUserProfilePageCreateServiceRequestAction'
import { useUserProfilePageDeleteAction } from '../useUserProfilePageDeleteAction'
import { useUserProfilePagePerformAction } from '../useUserProfilePagePerformAction'
import { useUserProfilePageSendInviteAction } from '../useUserProfilePageSendInviteAction'
import { useUserProfilePageSendMessageAction } from '../useUserProfilePageSendMessageAction'
import { useUserProfilePageStatusActions } from '../useUserProfilePageStatusActions'
import { useUserProfilePageUploadFileAction } from '../useUserProfilePageUploadFileAction'

export function useUserProfilePageHeaderFooterActions() {
  const { handlePerformMassAction, handleUpdateStatus } =
    useUserProfilePagePerformAction()

  const { handleOpenCreateContract, handleOpenEditAddressModal } =
    useUserProfilePageCreateContractAction({ handlePerformMassAction })

  const {
    handleClickApproveRegistration,
    handleClickArchive,
    handleClickBlock,
    handleClickRestore,
    handleClickUnblock,
  } = useUserProfilePageStatusActions({
    handleOpenEditAddressModal,
    handlePerformMassAction,
    handleUpdateStatus,
  })

  const { handleClickDelete } = useUserProfilePageDeleteAction()

  const { handleClickSendInvite } = useUserProfilePageSendInviteAction({
    handlePerformMassAction,
  })

  const { handleClickSendMessage } = useUserProfilePageSendMessageAction()

  const { handleClickCreateServiceRequest } =
    useUserProfilePageCreateServiceRequestAction()

  const { handleClickCreateFolder } = useUserProfilePageCreateFolderAction()

  const { handleClickCreateEmail } = useUserProfilePageCreateEmailAction()

  const { getUploadFileInputProps, handleClickUploadFile } =
    useUserProfilePageUploadFileAction()

  const actionHandlers = {
    [USER_PROFILE_PAGE_HEADER_FOOTER_ACTION.approveRegistration]:
      handleClickApproveRegistration,
    [USER_PROFILE_PAGE_HEADER_FOOTER_ACTION.archive]: handleClickArchive,
    [USER_PROFILE_PAGE_HEADER_FOOTER_ACTION.block]: handleClickBlock,
    [USER_PROFILE_PAGE_HEADER_FOOTER_ACTION.contract]: handleOpenCreateContract,
    [USER_PROFILE_PAGE_HEADER_FOOTER_ACTION.delete]: handleClickDelete,
    [USER_PROFILE_PAGE_HEADER_FOOTER_ACTION.email]: handleClickCreateEmail,
    [USER_PROFILE_PAGE_HEADER_FOOTER_ACTION.folder]: handleClickCreateFolder,
    [USER_PROFILE_PAGE_HEADER_FOOTER_ACTION.restore]: handleClickRestore,
    [USER_PROFILE_PAGE_HEADER_FOOTER_ACTION.sendInvite]: handleClickSendInvite,
    [USER_PROFILE_PAGE_HEADER_FOOTER_ACTION.sendMessage]:
      handleClickSendMessage,
    [USER_PROFILE_PAGE_HEADER_FOOTER_ACTION.serviceRequest]:
      handleClickCreateServiceRequest,
    [USER_PROFILE_PAGE_HEADER_FOOTER_ACTION.unblock]: handleClickUnblock,
    [USER_PROFILE_PAGE_HEADER_FOOTER_ACTION.upload]: handleClickUploadFile,
  }

  return {
    actionHandlers,
    getUploadFileInputProps,
  }
}
